import script from "./ProductView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductView.vue?vue&type=script&lang=ts&setup=true"

import "./ProductView.vue?vue&type=style&index=0&id=81fd5c64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81fd5c64"]])

export default __exports__